import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "person",
  "use": "person-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"person\"><path d=\"M18.7 17.35a6 6 0 10-5.4 0A11 11 0 005 28h2a9 9 0 0118 0h2a11 11 0 00-8.3-10.65zM12 12a4 4 0 114 4 4 4 0 01-4-4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/person.svg
// module id = 8dUg
// module chunks = 39 44